export default __webpack_public_path__ + "static/media/Roboto-Regular.d7d8aca5.ttf";